
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    Item: {
    ...apiFuns.genStandard("item","/api/ml"),
    queryExamineSet:(para)=>{
        return get(`/api/ml/set`,para)
    },
    queryStandard:(para)=>{
        return get(`/api/ml/standard`,para)
    }
  }
};
export default api;